<template>
  <Widget>
    <div
      :class="[
        isWelcome
          ? 'header-widget widget-color welcome-widget-image'
          : 'header-widget widget-color detailed-risk-widget-image',
      ]"
      :is="type"
    >
      <div class="header-text">
        <v-row>
          <AppkitIcon
            v-if="icon"
            class="pt-1 mr-2"
            :icon="icon"
            :style="{ color: 'white' }"
            size="large"
          />
          <h1>{{ headerText }}</h1>
        </v-row>
      </div>
    </div>
  </Widget>
</template>

<script setup lang="ts">
import Widget from "@/views/dashboard-view/Widget.vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { computed } from "vue";

const props = defineProps<{
  headerText: string;
  type: string;
  icon?: string;
}>();

const isWelcome = computed(() => props.type === "Welcome");
</script>

<style scoped lang="scss">
.header-widget {
  height: 120px;
  border-radius: 6px;
  text-align: left;
  background-position: right;
}

.header-text {
  padding-top: 55px;
  padding-left: 30px;
}
</style>
